(() => {
  const detectedCountry = () => {
    if (!window.gngShippingCountry) {
      const root = window.Shopify?.routes?.root || '/';
      window.gngShippingCountry = fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', {
        credentials: 'same-origin',
        signal: AbortSignal.timeout(5000)
      }).then(response => response.ok ? response.json() : null)
        .then(data => data?.detected_values?.country?.handle || null)
        .catch(() => null);
    }
    return window.gngShippingCountry;
  };
  class GngLocationBanner extends HTMLElement {
    async connectedCallback() {
      this.stopRotation();
      const country = await detectedCountry();
      if (!this.isConnected) return;
      this.messages = [...this.querySelectorAll('[data-country]')].filter(message => message.dataset.country === country);
      this.querySelectorAll('[data-country]').forEach(message => { message.hidden = true; });
      this.hidden = this.messages.length === 0;
      this.position = 0;
      this.paused = false;
      this.interacting = false;
      this.control = this.querySelector('[data-banner-toggle]');
      this.controlLabel = this.querySelector('[data-banner-control-label]');
      this.controlIcon = this.querySelector('[data-banner-control-icon]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.rotationAllowed = country === 'US' && this.messages.length > 1 && !reduceMotion;
      if (this.control) this.control.hidden = !this.rotationAllowed;
      if (!this.rotationAllowed) {
        this.messages.forEach(message => { message.hidden = false; });
        return;
      }
      this.messages[0].hidden = false;
      if (!this.eventsBound) {
        this.control.addEventListener('click', () => {
          this.paused = !this.paused;
          this.control.setAttribute('aria-pressed', String(this.paused));
          this.controlLabel.textContent = this.paused ? this.dataset.play : this.dataset.pause;
          this.controlIcon.textContent = this.paused ? '▶' : 'Ⅱ';
          this.startRotation();
        });
        this.addEventListener('mouseenter', () => { this.interacting = true; this.stopRotation(); });
        this.addEventListener('mouseleave', () => { this.interacting = false; this.startRotation(); });
        this.addEventListener('focusin', () => { this.interacting = true; this.stopRotation(); });
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) { this.interacting = false; this.startRotation(); }
        });
        this.eventsBound = true;
      }
      this.startRotation();
    }
    startRotation() {
      this.stopRotation();
      if (!this.rotationAllowed || this.paused || this.interacting) return;
      this.timer = setInterval(() => {
        this.messages[this.position].hidden = true;
        this.position = (this.position + 1) % this.messages.length;
        this.messages[this.position].hidden = false;
      }, 6000);
    }
    stopRotation() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }
    disconnectedCallback() { this.stopRotation(); }
  }
  class GngShippingProgress extends HTMLElement {
    connectedCallback() {
      this.cart = {
        total_price: Number(this.dataset.total),
        currency: this.dataset.currency,
        item_count: Number(this.dataset.count)
      };
      this.country = null;
      this.requestVersion = 0;
      this.hidden = true;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => this.onCartUpdate(event));
      }
      detectedCountry().then(country => {
        if (!this.isConnected) return;
        this.country = country;
        this.render();
      });
    }
    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      this.requestVersion++;
    }
    async onCartUpdate(event) {
      const version = ++this.requestVersion;
      const data = event?.cartData;
      if (data && typeof data.total_price === 'number' && data.currency && typeof data.item_count === 'number') {
        this.cart = data;
        this.render();
        return;
      }
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return;
        const cart = await response.json();
        if (!this.isConnected || version !== this.requestVersion) return;
        this.cart = cart;
        this.render();
      } catch {}
    }
    render() {
      const currencies = { CA: 'CAD', US: 'USD' };
      const currency = currencies[this.country];
      if (!currency || !this.cart.item_count) {
        this.hidden = true;
        return;
      }
      const name = this.country === 'CA' ? this.dataset.canada : this.dataset.usa;
      const text = this.querySelector('[data-shipping-message]');
      const progress = this.querySelector('progress');
      const note = this.querySelector('[data-shipping-note]');
      const format = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency, currencyDisplay: 'narrowSymbol'
      }).format(cents / 100) + ' ' + currency;
      this.hidden = false;
      if (this.cart.currency !== currency) {
        text.textContent = this.dataset.offer.replace('__country__', name).replace('__amount__', format(20000));
        note.textContent = this.dataset.switchCurrency.replace('__country__', name).replace('__currency__', currency);
        progress.hidden = true;
        return;
      }
      const subtotal = Math.max(0, Number(this.cart.total_price) || 0);
      const remaining = Math.max(0, 20000 - subtotal);
      text.textContent = remaining
        ? this.dataset.remaining.replace('__amount__', format(remaining)).replace('__country__', name)
        : this.dataset.unlocked.replace('__country__', name);
      progress.hidden = false;
      progress.value = Math.min(20000, subtotal);
      note.textContent = this.dataset.note;
    }
  }
  if (!customElements.get('gng-location-banner')) customElements.define('gng-location-banner', GngLocationBanner);
  if (!customElements.get('gng-shipping-progress')) customElements.define('gng-shipping-progress', GngShippingProgress);
})();